<template lang='pug'>
  router-view
</template>

<script>
  import store from './vuex/store'

  export default {
    name: 'App',
    store: store
  }
</script>

<style>
  @import 'assets/css/animations';
  @import 'assets/css/reset';
  @import 'assets/css/global';
</style>



// WEBPACK FOOTER //
// App.vue?b714b9c6